export const StepsSimulatore = {
  PROGETTO: 1,
  SUBPROGETTO:11,
  IMPORTO: 2,
  RATA: 3,
  ASSICURAZIONE: 4,
  OFFERTA: 5
} as const

export type StepsSimulatore = (typeof StepsSimulatore)[keyof typeof StepsSimulatore]
